const unitQuotes = [ // договор 131895 от 12-12-2024
  {
    "quote": 1000,
    "quotesdate": "2024-11-06"
  },
  {
    "quote": 1000,
    "quotesdate": "2024-11-07"
  },
  {
    "quote": 992.32,
    "quotesdate": "2024-11-08"
  },
  {
    "quote": 1002.92,
    "quotesdate": "2024-11-11"
  },
  {
    "quote": 1003.16,
    "quotesdate": "2024-11-12"
  },
  {
    "quote": 1007.76,
    "quotesdate": "2024-11-13"
  },
  {
    "quote": 998.51,
    "quotesdate": "2024-11-14"
  },
  {
    "quote": 1003.19,
    "quotesdate": "2024-11-15"
  },
  {
    "quote": 1002.72,
    "quotesdate": "2024-11-18"
  },
  {
    "quote": 1009.27,
    "quotesdate": "2024-11-19"
  },
  {
    "quote": 1011.16,
    "quotesdate": "2024-11-20"
  },
  {
    "quote": 1013.75,
    "quotesdate": "2024-11-21"
  },
  {
    "quote": 1009.43,
    "quotesdate": "2024-11-22"
  },
  {
    "quote": 1008.56,
    "quotesdate": "2024-11-23"
  },
  {
    "quote": 1008.56,
    "quotesdate": "2024-11-25"
  },
  {
    "quote": 1004.21,
    "quotesdate": "2024-11-26"
  },
  {
    "quote": 998.05,
    "quotesdate": "2024-11-27"
  },
  {
    "quote": 994.03,
    "quotesdate": "2024-11-28"
  },
  {
    "quote": 991.44,
    "quotesdate": "2024-11-29"
  },
  {
    "quote": 995.53,
    "quotesdate": "2024-12-02"
  },
  {
    "quote": 996.88,
    "quotesdate": "2024-12-03"
  },
  {
    "quote": 992.95,
    "quotesdate": "2024-12-04"
  },
  {
    "quote": 990.14,
    "quotesdate": "2024-12-05"
  },
  {
    "quote": 986.26,
    "quotesdate": "2024-12-06"
  },
  {
    "quote": 985.59,
    "quotesdate": "2024-12-09"
  }
]

export {
  unitQuotes
}